import {styled} from "@mui/material/styles"
import Button from "@mui/material/Button"

export const DefaultOpenFiltersButton = styled(Button)`
    && {
        background: ${({theme}) => theme.colours.form.buttonSecondary.background};
        border: ${({theme}) => theme.colours.form.buttonSecondary.border};
        border-radius: ${({theme}) => theme.colours.form.buttonSecondary.radius};
        color: ${({theme}) => theme.colours.form.buttonSecondary.color};
        font-family: ${({theme}) => `${theme.colours.font.primary.regular.family}, ${theme.colours.font.default}`};
        font-size: 0.75rem;
        height: 2.25rem;
        text-transform: uppercase;
        min-width: 7.0625rem;
        max-width: 13.375rem;
        margin-bottom: 0.375rem;

        &:hover,
        &:active,
        &:focus {
            background: ${({theme}) => theme.colours.form.buttonSecondary.background};
            border: ${({theme}) => theme.colours.form.buttonSecondary.border};
            color: ${({theme}) => theme.colours.form.buttonSecondary.color};
        }
    }
`

export const CTAWrapper = styled("div")`
    width: 8rem;
    font-size: small;
`
